module.exports = __webpack_public_path__ + "static/station-with-modules-cbf56c7ad7273ee675a84d2e8a3da404.jpg";